module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-card-5"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showBullets) ? _c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns n1 align-self-middle"
  }, [_vm._t("n1")], 2), _c('div', {
    staticClass: "columns n2 align-self-middle"
  }, [_vm._t("n2")], 2), _c('div', {
    staticClass: "columns n3 align-self-middle"
  }, [_vm._t("n3")], 2), _c('div', {
    staticClass: "columns n4 align-self-middle"
  }, [_vm._t("n4")], 2), _c('div', {
    staticClass: "columns n5 align-self-middle"
  }, [_vm._t("n5")], 2)])]), (_vm.showAction) ? _c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_vm._t("actionPage")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c14063d8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Card5.vue
// module id = 2687
// module chunks = 1